"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var treeManager_1 = require("./treeManager");
var calcBaseItem_1 = require("./calcBaseItem");
var nonPosterDataController_1 = require("./nonPosterDataController");
var mmxlGetter_1 = require("./datalayerHelpers/mmxlGetter");
var CalcBaseController = (function () {
    function CalcBaseController() {
    }
    CalcBaseController.prototype.updateBaseInfos = function (placement, ratecardOptions) {
        var _this = this;
        return mmxlGetter_1.MmxlGetter.getRateCard(placement.medium.key, ratecardOptions)
            .then(function (rateCard) {
            if (!rateCard) {
                return;
            }
            var adFormat = _.get(placement, "conditions.online.adFormat");
            var promisesToDo = new Array();
            promisesToDo.push(_this.getFrequencyCapping(rateCard, adFormat));
            promisesToDo.push(_this.getTargeting(rateCard, adFormat, placement.targeting));
            var cpm = nonPosterDataController_1.NonPosterDataController.getRatecardCpm(rateCard, adFormat);
            var currentAdformat = CalcBaseController.getCurrentAdformat(rateCard.adFormats, adFormat);
            var fixedPrice;
            if (currentAdformat) {
                fixedPrice = CalcBaseController.getFixedPrice(placement.medium.period, currentAdformat.fixedPrices);
            }
            return Promise.all(promisesToDo).then(function (result) {
                var theFcKit = result[0], theTKits = result[1];
                var newItem = new calcBaseItem_1.CalcBaseItem(theFcKit, theTKits, cpm, fixedPrice, adFormat);
                return newItem;
            });
        });
    };
    CalcBaseController.getCurrentAdformat = function (rateCardAdformats, adformat) {
        return _.find(rateCardAdformats, function (candidate) {
            return candidate.id === adformat;
        });
    };
    CalcBaseController.getFixedPrice = function (period, fixedPrices) {
        if (!fixedPrices) {
            return;
        }
        var resultFixedPrice = _.find(fixedPrices, (function (item) {
            return item.period.toUpperCase() === period.toUpperCase();
        }));
        return _.get(resultFixedPrice, "amount");
    };
    CalcBaseController.prototype.getFrequencyCapping = function (rateCard, adformat) {
        if (rateCard.frequencyCapping) {
            return mmxlGetter_1.MmxlGetter.getFrequencyCappingKits(rateCard.frequencyCapping).then(function (fcKits) {
                var currentKit = _.find(fcKits[0].extraCharges, (function (candidate) {
                    return candidate.adFormat === adformat;
                }));
                return currentKit;
            });
        }
        else {
            return CalcBaseController.getNullPromise();
        }
    };
    CalcBaseController.prototype.getTargeting = function (rateCard, adformat, targeting) {
        if (rateCard.targeting && _.get(targeting, "keys")) {
            return mmxlGetter_1.MmxlGetter.getTargetingKits(rateCard.targeting).then(function (tKits) {
                var targetingKeys = targeting.keys.map(function (key) {
                    return treeManager_1.TreeManager.getCode(key);
                });
                var currentKits = _.filter(tKits[0].extraCharges, (function (candidate) {
                    return _.contains(targetingKeys, candidate.code) && candidate.adFormat === adformat;
                }));
                return currentKits;
            });
        }
        else {
            return CalcBaseController.getNullPromise();
        }
    };
    CalcBaseController.getNullPromise = function () {
        return new Promise(function (resolve, reject) {
            resolve(undefined);
        });
    };
    return CalcBaseController;
}());
exports.CalcBaseController = CalcBaseController;
//# sourceMappingURL=calcBaseController.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/calcBaseController.js
// module id = 42
// module chunks = 0